/* ALBEUX: THE "ADD TO SHOPPING BAG" BAR ON A PRODUCT PAGE THAT ARRIVES BY THE SLIDE (2 Nov 2026, v2 on 3 Nov 2026).
   On a product page that slid in from a collection page, the theme's own styles and script for that bar (the sticky bar) are not there, so it showed as a dead black strip under the header,
   pushed the page down, and disappeared (a lift and a blink) when the page slid out again.
   v2: on such a page the strip is not shown at all (it is hidden the moment the page is built in, before anything is drawn). Nothing else is touched.
   It only acts while the slide is building a page (html.alb-zooming) and only when the theme's own script for the bar is NOT running (customElements has no sticky-add-to-cart).
   Product pages opened directly, and pages built from them, keep the theme's own bar exactly as it was.
   v1 (kept): if the bar is ever pressed while the theme's script is not running, it presses the real "Add to shopping bag" button of the same page.
   To undo, delete the albeux-bar-tap line in snippets/view-transition-opt-in.liquid. */
(function () {
  'use strict';
  if (window.__albBarTap) return;
  window.__albBarTap = true;
  var d = document.documentElement;
  function dead() { return !(window.customElements && customElements.get('sticky-add-to-cart')); }
  function hide(n) {
    try {
      if (n.nodeType !== 1) return;
      var list = [];
      if (n.matches && n.matches('sticky-add-to-cart')) list.push(n);
      if (n.querySelectorAll) { var q = n.querySelectorAll('sticky-add-to-cart'); for (var i = 0; i < q.length; i++) list.push(q[i]); }
      for (var j = 0; j < list.length; j++) list[j].style.setProperty('display', 'none', 'important');
    } catch (e) {}
  }
  try {
    if ('MutationObserver' in window && document.body) {
      new MutationObserver(function (recs) {
        if (!d.classList.contains('alb-zooming') || !dead()) return;
        for (var i = 0; i < recs.length; i++) {
          var a = recs[i].addedNodes;
          for (var k = 0; k < a.length; k++) hide(a[k]);
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  } catch (e) {}
  document.addEventListener('click', function (e) {
    try {
      var t = e.target;
      if (!t || !t.closest) return;
      var bar = t.closest('sticky-add-to-cart .sticky-add-to-cart__button');
      if (!bar) return;
      if (window.customElements && customElements.get('sticky-add-to-cart')) return;
      var main = bar.closest('main');
      if (!main) return;
      var real = main.querySelector('product-form-component [ref="addToCartButton"], product-form-component button[name="add"]');
      if (!real || real.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      real.click();
    } catch (err) {}
  }, true);
})();